import React, { createContext } from 'react'
import { arrangeListingData, ListingHeaders } from '../utils/ListingHelpers'
import { calculateDecimal } from '../utils/helpers'

const ItemsListContext = createContext({})

const ItemsListProvider = ({ listArr, entityName, all, currency, locale, netTotal, totalTaxableFees, calculatedFees, valueDifference, onListUpdate, children }) => {
  const [isDialogOpen, setIsDialogOpen] = React.useState(false)
  React.useEffect(() => {
      if (!!entityName) {
        setListingPage(0)
        setListingHeader(ListingHeaders[entityName])
      }
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    [])

  const [listingHeader, setListingHeader] = React.useState([])
  const [listingRowsPerPage, setListingRowsPerPage] = React.useState(10)
  const [listingLoading, setListingLoading] = React.useState(false)
  const [allListingData, setAllListingData] = React.useState(listArr || [])
  const [listingData, setListingData] = React.useState([])
  const [currentSelectedRow, setCurrentSelectedRow] = React.useState({})
  const [currentDialogAction, setCurrentDialogAction] = React.useState('')
  const [listingPage, setListingPage] = React.useState(-1)
  const [listingCount, setListingCount] = React.useState(listArr?.length || 0)
  const [deleteItemLoading, setDeleteItemLoading] = React.useState(false)


  React.useEffect(() => {
      if (listingPage > -1) {
        getListingData()
      }
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    [listingPage, listingRowsPerPage])

  React.useEffect(() => {
      if (!!listArr?.length) {
        setAllListingData(listArr || [])
        setListingCount(listArr?.length || 0)
        getListingData(null, listArr)
      }
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    [listArr])

  React.useEffect(() => {
      return () => setListingLoading(false)
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    [])

  React.useEffect(() => {
      // if (entityName === 'taxableItems') {
      let data = allListingData?.length ? allListingData : listArr || []
      data.forEach(item => {
        let value = (parseFloat((['T1', 'T2'].includes(item.type)) ? parseFloat(netTotal) + (parseFloat(valueDifference) || 0) + parseFloat(item.type === 'T1' ? totalTaxableFees : calculatedFees) : netTotal) || 0) * ((parseFloat(item.rate) || 0) / 100)
        item.calculatedValue = calculateDecimal(value.toString())
        if (!item?.valueEdit) {
          item.value = calculateDecimal(value.toString())
        }
      })
      setAllListingData(arrangeListingData(entityName, data, currency, locale))
      if (!!data?.length && !!onListUpdate) {
        onListUpdate(arrangeListingData(entityName, data, currency, locale))
      }
      // }
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    [totalTaxableFees, calculatedFees, valueDifference, netTotal])

  React.useEffect(() => {
      if (!!allListingData?.length && !!onListUpdate) {
        onListUpdate(allListingData)
      }
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    [allListingData])

  const handleChangeListingPage = (newPage) => {
    setListingPage(newPage)
  }

  const handleChangeListingRowsPerPage = (newRows) => {
    setListingRowsPerPage(+newRows)
    setListingPage(0)
  }

  const getListingData = (updateParentEntity, newData) => {
    if (!newData) {
      newData = allListingData || []
    }
    setListingLoading(true)
    if (!!newData) {
      setListingCount(newData?.length)
      setListingData(arrangeListingData(entityName, !!all ? newData : newData.slice(listingPage * listingRowsPerPage, (listingPage + 1) * listingRowsPerPage), currency, locale))
    }
    if (!!updateParentEntity) {
      updateParentEntity(arrangeListingData(entityName, !!all ? newData : newData.slice(listingPage * listingRowsPerPage, (listingPage + 1) * listingRowsPerPage), currency, locale))
    }
    setTimeout(() => setListingLoading(false), 500)
  }

  const dialogActionSubmit = (values, FormikActions, updateParentEntity, isCreate) => {
    // debugger;
    if (currentDialogAction === 'delete' && !isCreate) {
      setDeleteItemLoading(true)
      let dataIndex = allListingData?.map(item => item?.id?.toString()).indexOf(currentSelectedRow?.id?.toString())
      if (dataIndex > -1) {
        let data = allListingData
        data.splice(dataIndex, 1)
        setAllListingData(data)
      }
    } else {
      let newData = arrangeListingData(entityName, [values], currency, locale)
      newData = !!newData?.length ? newData[0] : newData
      if (!!newData && !!Object.keys(newData || {})?.length) {
        newData.id = newData?.id || (listingData?.length ? listingData[listingData?.length - 1]?.id + 1 : 1)
        setCurrentSelectedRow({ ...currentSelectedRow, ...newData } || {})
        let dataIndex = allListingData?.map(item => item?.id?.toString()).indexOf(newData?.id?.toString())
        if (dataIndex > -1) {
          let data = allListingData
          data[dataIndex] = newData
          setAllListingData(data)
        } else {
          let data = allListingData
          data.push(newData)
          setAllListingData(data)
        }
      }
    }
    setTimeout(() => {
      cancelDialog()
      setTimeout(() => {
        getListingData(updateParentEntity)
        // if (!!updateParentEntity) {
        //   setTimeout(() => updateParentEntity(listingData), 500)
        // }
      }, 300)
    }, 200)
    // cancelDialog()
    // setTimeout(() => {
    //   getListingData(updateParentEntity)
    //   // if (!!updateParentEntity) {
    //   //   setTimeout(() => updateParentEntity(listingData), 500)
    //   // }
    // }, 500)

    setTimeout(() => {
      setDeleteItemLoading(false)
      if (!!FormikActions) {
        FormikActions.setSubmitting(false)
      }
    }, 300)
  }


  const openDialog = (type, selectedRow, id, handleMenuClose, updateParentEntity) => {
    if (!!handleMenuClose) {
      handleMenuClose()
    }
    setCurrentSelectedRow(selectedRow || {})
    setCurrentDialogAction(type || 'create')
    if (type === 'delete') {
      deleteRecord(selectedRow, id, updateParentEntity ?? onListUpdate)
    } else {
      setIsDialogOpen(!isDialogOpen)
    }
  }

  const deleteRecord = (selectedRow, id, updateParentEntity) => {
    let dataIndex = (!!all ? allListingData : listingData)?.map(item => item?.id?.toString()).indexOf(selectedRow?.id?.toString())
    if (dataIndex > -1) {
      let data = !!all ? allListingData : listingData
      data.splice(dataIndex, 1)
      !!all ? setAllListingData(data) : setListingData(data)
    }
    setTimeout(() => {
      getListingData(updateParentEntity)
      // if (!!updateParentEntity) {
      //   setTimeout(() => updateParentEntity(listingData), 500)
      // }
    }, 300)
  }

  const cancelDialog = () => {
    setIsDialogOpen(false)
  }
  return (
    <ItemsListContext.Provider value={{
      entityName,
      // currency,
      // locale,

      listingData,
      listingLoading,

      listingCount,
      listingRowsPerPage,
      listingPage,
      handleChangeListingPage,
      handleChangeListingRowsPerPage,

      isDialogOpen,
      openDialog,
      cancelDialog,

      currentSelectedRow,
      currentDialogAction,
      listingHeader,

      dialogActionSubmit,
      deleteItemLoading

    }}>
      {children}
    </ItemsListContext.Provider>
  )
}
const ItemsListConsumer = ItemsListContext.Consumer

export { ItemsListProvider, ItemsListConsumer }
